import { Graph, Item } from '@antv/g6';

const stageMap = {
  PRD: '项目预研',
  PI: '项目立项',
  DD: '项目尽调',
  PD: '项目决策',
  PP: '项目公示',
  SA: '协议签订',
  IE: '投资执行',
  PIM: '投后管理',
  PE: '项目退出'
};
const progressMap = {
  EXPERT_REVIEW: '专家评审',
  INIT_PROJECT: '发起立项',
  PROJECT_CONCLUSION: '立项结论',
  PROJECT_DUE: '项目尽调',
  COM_GROUP_DECISION: '主管部门决策&工投集团决策',
  COMPENT_DEPART_DECISION: '主管部门决策',
  GROUP_DECISION: '工投集团决策',
  CITY_HALL_DECISION: '市政府决策',
  FIN_ECON_COMM_DECISION: '财经委决策',
  PROJECT_SHOW: '项目公示',
  SIGN_PROJECT_INVESTMENT: '项目投资协议',
  SIGN_FUND_INVESTMENT: '基金投资协议',
  INVESTMENT_EXECUT: '投资执行',
  MANAGER_LATER: '投后管理',
  PROJECT_PROGRESS: '项目进展',
  PROJECT_EXIT: '项目退出'
};

export const registerNode = (G6) => {
  G6.registerNode('CUSTOM_NODE', {
    draw: (cfg, group) => {
      return group!.addShape('dom', {
        attrs: {
          width: 250,
          height: 94,
          // 传入 DOM 的 html
          html: `
              <div class="node-box ${cfg.dealState && 'active'}">
                <div class="node-head">
                  <span class="check-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" data-v-ea893728=""><path fill="currentColor" d="M406.656 706.944 195.84 496.256a32 32 0 1 0-45.248 45.248l256 256 512-512a32 32 0 0 0-45.248-45.248L406.592 706.944z"></path></svg>
                  </span>
                  <span class="title">${stageMap[cfg.stageEnum]}</span>
                  <span class="state">${progressMap[cfg.nodeEnum]}</span>
                </div>
                <span class="dot"></span>
                <div class="node-footer">
                  <span class="check-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" data-v-ea893728=""><path fill="currentColor" d="M406.656 706.944 195.84 496.256a32 32 0 1 0-45.248 45.248l256 256 512-512a32 32 0 0 0-45.248-45.248L406.592 706.944z"></path></svg>
                  </span>
                  <span class="name">${cfg.dealStaffName || ''}</span>
                  <span class="time">${cfg.dealTime || ''}</span>
                </div>
              </div>
          `
        }
      });
    }
  });
};

// https://g6.antv.vision/manual/advanced/coordinate-system
export const moveItemToCenter = (item: Item, graph: Graph) => {
  const matrix = item.get('group').getMatrix();
  const point = {
    x: matrix[6],
    y: matrix[7]
  };
  const width = graph.getWidth();
  const height = graph.getHeight();
  // 找到视口中心
  const viewCenter = {
    x: width / 2,
    y: height / 2
  };
  const modelCenter = graph.getPointByCanvas(viewCenter.x, viewCenter.y);
  const viewportMatrix = graph.get('group').getMatrix() || [1, 0, 0, 0, 1, 0, 0, 0, 1];
  // const ty = graph.getPointByCanvas(0, item._cfg!.bboxCache.height * 0.25).y;
  // 画布平移的目标位置，最终目标是graph.translate(dx, dy);
  const dx = (modelCenter.x - point.x) * viewportMatrix[0];
  const dy = (modelCenter.y - point.y) * viewportMatrix[4] - 40;
  graph.translate(dx, dy, true, {
    duration: 500
  });
};
